import * as _ from 'underscore';

import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
// import { Component, OnInit } from '@angular/core';
import { PrerollCreativeR5Component } from '../preroll-creative-r5/preroll-creative-r5.component';

@Component({
	selector: 'app-ctv-creative-r5',
	styleUrls: ['../preroll-creative-r5/preroll-creative-r5.component.css'],
	templateUrl: '../preroll-creative-r5/preroll-creative-r5.component.html'
})
export class CtvCreativeR5Component extends PrerollCreativeR5Component implements OnInit {
	@Input() sectionclass: string;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.sortedCreatives = this.creatives;
			const videoCreatives = _.where(this.sortedCreatives, { isVideoCreative: true });
			this.isVideoCreative = videoCreatives.length > 0;
			const selectedLegend: any = _.findWhere(this.legend, { selected: true });
		} else {
			this.hasData = false;
		}
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
	ngAfterViewChecked(): void {
		super.ngAfterViewChecked();
	}
	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}
	ngAfterContentChecked(): void {
		super.ngAfterContentChecked();
	}
}
